import {
  blue,
  green,
  red
} from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import * as DefaultRoutes from "../../../AppRoutes/DefaultRoutes";
import GenericHomePage from "../../GenericHomePage/GenericHomePage";
import PublicIcon from '@mui/icons-material/Public';
const AdminHome = () => {
  const navigate = useNavigate();

  const theme = useTheme();
  let sectionsBox = [
    {
      textBeside: "Users", // Label displayed next to the icon
      icon: PersonAddAltRoundedIcon, // MUI Icon component
      iconColor: blue[800], // Icon color
      iconFontSize: theme.spacing(10), // Icon size
      boxbackgroundColor: blue[50], // Box background color
      size: 4,
      onClick: () => navigate(DefaultRoutes.users),
    },
    {
      textBeside: "Categories",
      icon: CategoryRoundedIcon,
      iconColor: red[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: red[50],
      size:4,
      onClick: () => navigate(DefaultRoutes.categories),
    },
    {
      textBeside: "Regions",
      icon: PublicIcon,
      iconColor: green[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: green[50],
      size:4,
      onClick: () => navigate(DefaultRoutes.regions),
    }
  ];

  return <GenericHomePage sectionsBox={sectionsBox} />;
};

export default AdminHome;
